import Txt from 'components/atoms/Txt/Txt';
import Logo from './assets/Sun_logo.svg';
import classes from './TheSunHeaderLogo.module.scss';

interface Props {
  className?: string;
}

const TheSunHeaderLogo: React.FC<Props> = ({ className }) => {
  return (
    <div className={classes.root}>
      <Txt component="p" className={classes.description}>
        In partnership with
      </Txt>{' '}
      <Logo className={classes.logo} />
    </div>
  );
};

export default TheSunHeaderLogo;
